import type { ReactNode } from 'react';
import type { PermissionCode } from '@/constants/permissions';
import { usePermissions } from '@/features/auth/hooks/usePermissions';

interface CanProps {
  code?: PermissionCode | undefined;
  any?: PermissionCode[] | undefined;
  children: ReactNode;
  fallback?: ReactNode | undefined;
}

export function Can({ code, any, children, fallback = null }: CanProps) {
  const { can, canAny } = usePermissions();
  const allowed = any === undefined ? can(code) : canAny(any);

  return <>{allowed ? children : fallback}</>;
}
